<template>
  <div
    class="columns is-mobile has-text-centered is-paddingless is-marginless toast"
    :class="type"
  >
    <div class="column" v-html="message" />
    <button class="close column is-narrow" @click="$emit('close')">x</button>
  </div>
</template>

<script>
export default {
  name: 'Toast',
  props: {
    message: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'info',
      validator: (value) => {
        return ['info', 'success', 'error'].indexOf(value) !== -1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.toast {
  position: absolute;
  width: 100%;
  z-index: $zindex-toast;
}

.close {
  cursor: pointer;
  font-size: 24px;
  padding-top: 8px;
  background-color: inherit;
  color: inherit;
  border: 0;
}

.success {
  color: $success;
  background-color: $notification-background-sucess;
}

.info {
  color: $info;
  background-color: $notification-background-info;
}

.error {
  color: $danger;
  background-color: $notification-background-error;
}
</style>
